export const PREVIEW_SIZES = 'Preview Size';
export const PREVIEW_SHADES = 'Preview Shades';
export const VIEW_SHADES = 'VIEW_SHADES';
export const VIEW_SIZES = 'VIEW_SIZES';
export const CONFIGURE_TYPE = {
    SHADE: 'shade',
    WEIGHT_CONFIGURE: 'weight_configure',
    SIZE: 'size',
};
export var variantTypes;
(function (variantTypes) {
    variantTypes["SIZE"] = "SIZE";
    variantTypes["SHADE"] = "SHADE";
    variantTypes["SIMPLE"] = "SIMPLE";
    variantTypes["BUNDLE"] = "BUNDLE";
})(variantTypes || (variantTypes = {}));
export const SHADE_LOADER_COUNT = 12;
export const SIZE_LOADER_COUNT = 3;
